<ng-template #window>
  <span *ngIf="true === servicesOk">
    <nb-icon icon="check"
             status="success"
             pack="fa"></nb-icon>
    {{ 'HEALTHCHECK.EXTERNALSERVICES.OK' | translate }}
  </span>
  <span *ngIf="false === servicesOk">
    <nb-icon icon="exclamation-triangle"
             status="danger"
             pack="fa"></nb-icon>
    {{ 'HEALTHCHECK.EXTERNALSERVICES.NOTOK' | translate }}
  </span>
</ng-template>
